import { activity_dates, concourseId } from '../constants/activity-constants'
import GameServices from '../services/game-service'
import isSSR from './isSSR'

export default function updateConcourseDates() {
  if (isSSR()) {
    return
  }
  let ipAddress = sessionStorage.getItem('ipAddress')
  if (!ipAddress) {
    ipAddress = '127.0.0.1'
  }
  const config = {
    headers: {
      'Ip-Address': ipAddress,
    },
  }
  return GameServices.getConcourseInfo(concourseId, config)
    .then(res => {
      if (res.status === 200) {
        // console.log('home call res: ', res.data)
        activity_dates[0] = res.data.startDate
        activity_dates[1] = res.data.endDate
      }
    })
    .catch(e => {
      console.log('concourse Info error: ', e)
    })
}
